<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->

    <div class="form_title_wrapper">
      <h3>{{ $t("SalonProvider.salonDataEdit") }}</h3>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h4>
            {{ $t("SalonProvider.providerData") }}
          </h4>
          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('SalonProvider.phone')"
            v-model.trim="data.phone"
            required
          />
          <hr />
          <h4>
            {{ $t("SalonProvider.salonData") }}
          </h4>
          <!-- Start:: Logo Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="logo"
              @selectImage="logoSelectImage"
              :preSelectedImage="data.logo.path"
              :placeholder="$t('SalonProvider.salonLogo')"
              required
            />
          </div>
          <!-- End:: Item Image -->
          <!-- Start:: laundry Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonNameAr')"
            v-model.trim="data.salonNameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonNameEn')"
            v-model.trim="data.salonNameEn"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('SalonProvider.salonPhone')"
            v-model.trim="data.salonPhone"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonEmail')"
            v-model.trim="data.salonEmail"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonDescAr')"
            v-model.trim="data.salonDescAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonDescEn')"
            v-model.trim="data.salonDescEn"
            required
          />
          <hr />

          <base-select-input
            class="placeholder_input"
            col="6"
            :optionsList="types"
            :placeholder="$t('SalonProvider.salonType')"
            v-model="whatType"
            required
            @input="isChecked = !whatType?.value == 'freelance'"
          />

          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              class="placeholder_input"
              col="6"
              color="green"
              :label="$t('SalonProvider.salonSubBranch')"
              v-if="whatType?.value == 'salon'"
              v-model="isChecked"
              hide-details
            ></v-switch>
          </div>

          <base-select-input
            v-if="isChecked && whatType?.value == 'salon'"
            class="placeholder_input"
            col="6"
            :optionsList="salons"
            :placeholder="$t('SalonProvider.mainSalonName')"
            v-model="data.subBranch"
            required
          />
          <!-- Start:: Item Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="commercial"
              @selectImage="comSelectImage"
              :preSelectedImage="data.commercialRegister.path"
              :placeholder="titleType"
              required
            />
          </div>
          <!-- End:: Item Image -->
          <div>
            <!-- Start:: Categories -->
            <h4>
              {{ $t("SalonProvider.salonCat") }}
            </h4>
            <base-select-input
              col="6"
              :optionsList="allCategories"
              :placeholder="$t('SalonProvider.categories')"
              v-model.trim="data.categories"
              :multiple="true"
              @remove="deleteCategory"
              required
            />
            <!-- End:: Categories -->
          </div>
          <hr />
          <h4>
            {{ $t("SalonProvider.salonAddress") }}
          </h4>
          <!-- Start:: Region Input -->
          <base-select-input
            class="placeholder_input"
            col="4"
            :optionsList="regions"
            :placeholder="$t('SalonProvider.salonRegion')"
            v-model="data.region"
            required
          />

          <!-- Start:: Address Input -->
          <base-input
            col="8"
            type="text"
            :placeholder="$t('SalonProvider.address')"
            v-model.trim="data.address"
            required
          />

          <!-- Start:: Map Address Input -->
          <div class="map_wrapper">
            <ChangableMapComponent
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
            />
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Delete Category Modal -->
    <v-dialog v-model="dialogDeleteCat">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("PLACEHOLDERS.deleteCategory") }}
        </v-card-title>

        <div class="table_image_wrapper mb-4" v-if="selectedCat">
          <h5>{{ selectedCat.name }}</h5>
        </div>
        <v-card-actions>
          <v-btn class="modal_confirm_btn" @click="deleteCategory()">
            {{ $t("BUTTONS.ok") }}
          </v-btn>

          <v-btn class="modal_cancel_btn" @click="dialogDeleteCat = false">{{
            $t("BUTTONS.cancel")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Delete Image Modal -->
  </div>
</template>

<script>
import ChangableMapComponent from "@/components/general/ChangableMapComponent.vue";

export default {
  name: "ShowJoinProvider",
  components: {
    ChangableMapComponent,
  },
  computed: {
    types() {
      return [
        {
          id: 0,
          name: this.$t("SalonProvider.salon"),
          value: "salon",
        },
        {
          id: 1,
          name: this.$t("SalonProvider.freelance"),
          value: "freelancer",
        },
      ];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        logo: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        phone: null,
        salonNameAr: null,
        salonNameEn: null,
        salonPhone: null,
        salonEmail: null,
        salonDescAr: null,
        salonDescEn: null,
        commercialRegister: {
          path: null,
          file: null,
        },
        categories: [],
        type: null,
        subBranch: null,
        region: null,
        address: null,
        lat: 23.848671758893115,
        lng: 44.64042782849206,
      },
      allCategories: [],
      regions: [],
      salons: [],
      whatType: null,
      catIndex: null,
      selectedCat: null,
      providerId: null,
      dialogDeleteCat: false,
      categoryLength: null,
      isChecked: false,
      titleType: null,
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Methods for Getting Required Data in Created Step
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            isActive: 1,
          },
        });
        this.regions = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories`,
          params: {
            isActive: 1,
          },
        });
        this.allCategories = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Salons To Show
    async getSalons() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `salons?ignorePermissionCheck=1`,
        });
        // Start:: Set Data
        const salonsData = res.data.data.data;
        console.log("salons", salonsData);
        this.salons = salonsData;
      } catch (error) {
        console.log(error);
      }
    },
    // Start:: Upload The Images Based on The input
    logoSelectImage(selectedImage) {
      this.data.logo = selectedImage;
    },
    comSelectImage(selectedImage) {
      this.data.commercialRegister = selectedImage;
    },
    // Start:: Delete Category Method
    async deleteCategory(removedOption) {
      try {
        await this.$axios({
          method: "DELETE",
          url: `/providers/${this.$route.params?.id}/categories/${removedOption.id}`,
        });
        this.dialogDeleteCat = false;
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },

    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });
        // Start:: Set Data
        const providerData = res.data.data.data;
        this.data.phone = providerData.mobile;
        this.data.logo.path = providerData.salon.logo;
        this.data.salonNameAr = providerData.salon.name_ar;
        this.data.salonNameEn = providerData.salon.name_en;
        this.data.salonPhone = providerData.salon.mobile;
        this.data.salonEmail = providerData.email;
        this.data.salonDescAr = providerData.salon.description_ar;
        this.data.salonDescEn = providerData.salon.description_en;
        this.data.type = providerData.salon.type;
        this.data.subBranch = providerData.salon.main_branch;
        this.data.commercialRegister.path = providerData.salon.document;
        this.data.categories = providerData.salon.categories;
        this.data.region = providerData.region;
        this.data.address = providerData.location.address;
        this.data.lat = providerData.location.lat;
        this.data.lng = providerData.location.long;
        // End:: Set Data
        this.isChecked = providerData.salon.main_branch ? true : false;
        if (this.data.type === "salon") {
          this.whatType = this.types[0];
        } else {
          this.whatType = this.types[1];
        }

        if (this.data.type === "salon" && !this.isChecked) {
          this.titleType = this.$t("SalonProvider.salonCommercialRegister");
        } else if (this.data.type === "salon" && this.isChecked) {
          this.titleType = this.$t("SalonProvider.subBranchCommercialRegister");
        } else {
          this.titleType = this.$t("SalonProvider.freelanceCommercialRegister");
        }

        console.log("providerData", providerData);

        this.categoryLength = this.data.categories?.length;
      } catch (error) {
        console.log(error);
      }
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
        // } else if (!this.data.password) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.password"));
        //   return;
        // } else if (this.data.password.length < 6) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.passwordLength"));
        //   return;
        // } else if (!this.data.passwordConfirmation) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.password"));
        //   return;
        // } else if (this.data.passwordConfirmation.length < 6) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.passwordLength"));
        //   return;
        // } else if (this.data.password != this.data.passwordConfirmation) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
        //   return;
      } else if (!this.data.logo.path) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.logo"));
        return;
      } else if (!this.data.salonNameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.salonNameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.salonPhone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonPhone"));
        return;
      } else if (!this.data.salonEmail) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.email"));
        return;
      } else if (!this.data.salonDescAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonDescAr"));
        return;
      } else if (!this.data.salonDescEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonDescEn"));
        return;
      } else if (!this.data.type) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonType"));
        return;
        // } else if (this.data.type.value === "salon" && !this.isChecked) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.salonSubBranch"));
        //   return;
      } else if (
        this.data.type.value === "salon" &&
        !this.data.subBranch &&
        this.isChecked
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mainSalonName"));
        return;
      } else if (!this.data.commercialRegister.path) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.commercialRegister"));
        return;
      } else if (!this.data.categories.length) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.categories"));
        return;
      } else if (!this.data.region) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.region"));
        return;
      } else if (!this.data.address) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.address"));
        return;
      } else if (!this.data.lat || !this.data.lng) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mapLocation"));
        return;
      } else {
        this.submitForm();
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.logo.file)
        REQUEST_DATA.append("salon[logo]", this.data.logo.file);
      if (this.data.commercialRegister.file)
        REQUEST_DATA.append(
          "salon[document]",
          this.data.commercialRegister.file
        );

      if (!this.isChecked) {
        REQUEST_DATA.append("salon[main_branch_id]", "");
      } else {
        REQUEST_DATA.append("salon[main_branch_id]", this.data.subBranch.id);
      }
      this.data.categories.forEach((cat) => {
        REQUEST_DATA.append("salon[category_ids][]", cat.id);
      });
      REQUEST_DATA.append("user[mobile]", this.data.phone);
      REQUEST_DATA.append("salon[mobile]", this.data.salonPhone);
      REQUEST_DATA.append("user[email]", this.data.salonEmail);
      REQUEST_DATA.append("salon[name][ar]", this.data.salonNameAr);
      REQUEST_DATA.append("salon[name][en]", this.data.salonNameEn);
      REQUEST_DATA.append("salon[description][ar]", this.data.salonDescAr);
      REQUEST_DATA.append("salon[description][en]", this.data.salonDescEn);
      REQUEST_DATA.append("salon[type]", this.whatType.value);
      REQUEST_DATA.append("user_info[lat]", this.data.lat);
      REQUEST_DATA.append("user_info[long]", this.data.lng);
      REQUEST_DATA.append("user_info[region_id]", this.data.region.id);
      REQUEST_DATA.append("user_info[address]", this.data.address);
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `providers/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToShow();
    this.getRegions();
    this.getCategories();
    this.getSalons();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.table_image_wrapper {
  margin-bottom: 25px;
}

.category_wrapper > span {
  background: #b67071;
  text-align: center;
  font-size: medium;
  color: white;
}
</style>
